//@flow
import React from 'react';
import i18n from 'app/common/lib/i18n';
// eslint-disable-next-line pinterest/no-deprecated-imports
import LegacyModal from 'app/common/react/ui/deprecated/LegacyModal';
import style from 'app/common/react/components/settings/UserSettingsPage/userSettingsModalStyles';
import { Box, Button } from 'gestalt';

type Props = {|
  error: { message: string },
  onHide: () => void,
|};

export default function ErrorModal(props: Props) {
  return (
    <LegacyModal onHide={props.onHide} type="confirm">
      <form className="standardForm" method="post" style={style.form}>
        <h1>{i18n._('Oops!')}</h1>
        <p className="body">{props.error.message}</p>
        <div className="formFooter" style={style.formFooter}>
          <Box alignItems="center" justifyContent="end" display="flex">
            <Button color="red" inline onClick={props.onHide} text={i18n._('Okay')} size="md" />
          </Box>
        </div>
      </form>
    </LegacyModal>
  );
}
